// src/utils/api.ts
import axios from "axios";

export const api = axios.create({
  withCredentials: true,
});

export async function apiFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  return fetch(input, {
    ...init,
    credentials: "include",
  });
}
